import React from 'react';

function Footer() {
  return (
    <div className="flex flex-col items-center w-full mt-8 border-t border-gray-200 pt-4 mx-auto max-w-[800px] px-4">
      <div className="flex flex-col items-center gap-3">
        <span className="text-gray-700 font-regular text-sm">Powered by tendent.ai • Integrity in Evaluation</span>
      </div>
    </div>
  );
}

export default Footer;
